import React from 'react';
import './ContactPage.css';
import Header from '../Header/Header';

const ContactPage = () => {
  return (
    <>
    <Header/>
    <div className="contact-container">
      <div className="contact-content">
        <h1>Contact Us</h1>
        <p>The employees can contact at the below address, in case of any query:</p>
        <address>
          HPTI Complex,<br />
          Sector 26,<br />
          Panchkula (Haryana).
        </address>
        <p>Alternatively, you can contact us at <a href="tel:0172-5210290">0172-5210290</a>.</p>
      </div>

    </div>
    </>
  );
};

export default ContactPage;
